import React, { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SearchResults } from '../../components/Documents/SearchResults';
import { useSearch } from '../../hooks/useSearch';
import { SearchDocument } from '../../services/searchService';

// Interface para o tipo esperado pelo SearchResults
interface SearchResult {
  id: string;
  title: string;
  type: 'document' | 'folder';
  path: string;
  lastModified: string;
  size?: string;
  tags?: string[];
  author?: string;
  category?: string;
}

// Função para converter SearchDocument para SearchResult
const mapSearchDocumentToSearchResult = (doc: SearchDocument): SearchResult => {
  return {
    id: doc.id,
    title: doc.title,
    type: (doc.nodeType || 'document') as 'document' | 'folder',
    path: doc.metadata?.Path || doc.path || `/documents/${doc.id}`,
    lastModified: doc.updatedAt || doc.createdAt || new Date().toISOString(),
    size: doc.metadata?.Size || undefined,
    tags: doc.metadata?.Tags || [],
    author: doc.metadata?.Author || '',
    category: doc.metadata?.Categories?.[0] || ''
  };
};

export const SearchPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const { results, isLoading, error, search } = useSearch();

  // Converter SearchDocument[] para SearchResult[]
  const convertedResults = useMemo(() => {
    return results.map(mapSearchDocumentToSearchResult);
  }, [results]);

  useEffect(() => {
    if (query) {
      search({ query });
    }
  }, [query, search]);

  return (
    <div className="flex-1 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">
            Resultados da busca: {query}
          </h1>
          {error && (
            <div className="mt-2 text-sm text-red-600">
              {error}
            </div>
          )}
        </div>
        <SearchResults results={convertedResults} isLoading={isLoading} query={query} />
      </div>
    </div>
  );
}; 